import { HttpHeaders } from '@angular/common/http';
import { ApolloClientOptions, ApolloLink, InMemoryCache, split } from '@apollo/client/core';
import { onError } from '@apollo/client/link/error';
import { getMainDefinition } from '@apollo/client/utilities';
import { HttpLink } from 'apollo-angular/http';
import { environment } from 'src/environments/environment';
import { AuthService } from './services/auth/auth.service';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
// @ts-ignore
import extractFiles from 'extract-files/extractFiles.mjs';
// @ts-ignore
import isExtractableFile from 'extract-files/isExtractableFile.mjs';

export function createApollo(httpLink: HttpLink, authService: AuthService): ApolloClientOptions<any> {

  const http = httpLink.create({
    uri: environment.graphQLUri,
    extractFiles: (body) => extractFiles(body, isExtractableFile)
  });

  const ws = new GraphQLWsLink(createClient({
    url:  environment.subscriptionsUri,
    shouldRetry: () => true,
    connectionParams: {
      authToken: authService.getSession() ? `Bearer ${authService.getSession()}` : undefined
    }
  }));

  const error = onError(({ graphQLErrors, networkError, response, operation }) => {
    const error: any = networkError;
    
    if (error) {
      if (error.status === 401 || error.status === 403) {
        authService.removeSession();
      };

      console.log(`[Network error]: ${networkError}`);
    };
  });

  const middleware = new ApolloLink((operation, forward) => {
    const token = authService.getSession();
    if (token) {
      let headers = new HttpHeaders();
      headers = headers.append('Authorization', `Bearer ${token}`);
      headers = headers.append('apollo-require-preflight', 'true');
      operation.setContext({
        headers
      });
    };

    modifyFilters(operation);

    return forward(operation);
  });

  const modifyFilters = (operation: any) => {
    const filters = operation.variables?.filter?.filters;
    if (filters) {
      for (const key in filters) {
        if (Array.isArray(filters[key])) {
          filters[key] = filters[key][0];
        }
      }
    }
  };  

  const link = ApolloLink.from([
    error,
    middleware,
    split(
      ({ query }) => {
        const definition = getMainDefinition(query);
        return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
      },
      ws,
      http
    )
  ]);

  return {
    link: link,
    cache: new InMemoryCache({
      addTypename: false
    }),
    defaultOptions: {
      query: {
        fetchPolicy: "no-cache"
      }
    }
  };
}